
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ChatAttachment } from '../../lib/chat/ChatAttachment'

@Component({})
export default class ChatMessageDocumentComponent extends Vue {
  @Prop({ default: () => new ChatAttachment() }) chatAttachment!: ChatAttachment
}
